<template>
  <span></span>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';

const PRODUCT_NAME_KEY = '[product name]';
const PRODUCT_ID_KEY = '[product id]';
const RETAILER_NAME_KEY = '[retailer name]';
const PAGE_CATEGORY_KEY = '[page category]';
const PRODUCT_SPU_KEY = '[product spu]';
const PRODUCT_CATEGORY_KEY = '[product category]';

/* eslint-disable eqeqeq */
export default {
  name: 'rfp-mctb-tags',
  data() {
    return {
      overallRatingReview: 0,
      productName: '',
      productID: '',
      retailerName: '',
      datalayers: '',
      datasss: '',
      extraParams: '',
    };
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('rfpTaggingFoundation', this.rfpTaggingFoundation);

    /* istanbul ignore next */
    eventBus.on('rfpTaggingFoundationGS', this.rfpTaggingFoundationGS);
  },
  methods: {
    rfpTaggingFoundation({ data, values, extraParams }) {
      const obj = this.processTagsJson(data, values, extraParams);
      /* istanbul ignore next */
      if (window.dataLayer !== undefined) {
        /* istanbul ignore next */
        dataLayer.push(obj); // eslint-disable-line no-undef
      }
    },
    rfpTaggingFoundationGS({ data, values, extraParams }) {
      const obj = this.processTagsJson(data.EventProperties, values, extraParams);
      /* istanbul ignore next */
      if (window._gsq !== undefined) {
        /* istanbul ignore next */
        _gsq.push(['track', data.EventName, obj]); // eslint-disable-line no-undef
      }
    },
    processTagsJson(data, values, extraParams) {
      const obj = {};
      if (!data || !values) return obj;
      const replaceProductName = values.productName.replace(/<\/?[^>]+(>|$)\n/g, '');
      let originalMsg = JSON.stringify(data);
      if (originalMsg.includes(PRODUCT_NAME_KEY)) {
        if (values.productName != undefined) {
          originalMsg = originalMsg.replaceAll(
            PRODUCT_NAME_KEY,
            replaceProductName
              .replace(/<\/?[^>]+(>|$)/g, ' ')
              .toLowerCase()
              .trim(),
          );
        } else {
          originalMsg = originalMsg.replaceAll(PRODUCT_NAME_KEY, '');
        }
      }
      if (originalMsg.includes(PRODUCT_ID_KEY)) {
        // eslint-disable-next-line eqeqeq
        if (values.productId != undefined) {
          originalMsg = originalMsg.replaceAll(PRODUCT_ID_KEY, values.productId.toString());
        } else {
          originalMsg = originalMsg.replaceAll(PRODUCT_ID_KEY, '');
        }
      }
      if (originalMsg.includes(RETAILER_NAME_KEY)) {
        if (values.retailerName != undefined) {
          originalMsg = originalMsg.replaceAll(
            RETAILER_NAME_KEY,
            values.retailerName.toLowerCase(),
          );
        } else {
          originalMsg = originalMsg.replaceAll(RETAILER_NAME_KEY, '');
        }
      }
      if (originalMsg.includes(PAGE_CATEGORY_KEY)) {
        if (extraParams !== undefined && extraParams.pageCategory !== undefined) {
          originalMsg = originalMsg.replaceAll(
            PAGE_CATEGORY_KEY,
            extraParams.pageCategory.toLowerCase(),
          );
        } else {
          originalMsg = originalMsg.replaceAll(PAGE_CATEGORY_KEY, '');
        }
      }
      if (originalMsg.includes(PRODUCT_SPU_KEY)) {
        if (extraParams !== undefined && extraParams.productSpu !== undefined) {
          originalMsg = originalMsg.replaceAll(
            PRODUCT_SPU_KEY,
            extraParams.productSpu.toLowerCase(),
          );
        } else {
          originalMsg = originalMsg.replaceAll(PRODUCT_SPU_KEY, '');
        }
      }
      if (originalMsg.includes(PRODUCT_CATEGORY_KEY)) {
        if (extraParams !== undefined && extraParams.productCategory !== undefined) {
          originalMsg = originalMsg.replaceAll(
            PRODUCT_CATEGORY_KEY,
            extraParams.productCategory.toLowerCase(),
          );
        } else {
          originalMsg = originalMsg.replaceAll(PRODUCT_CATEGORY_KEY, '');
        }
      }
      originalMsg = originalMsg.replaceAll('::::', '::');
      for (const [key, value] of Object.entries(JSON.parse(originalMsg.replaceAll('\n', '\\n')))) {
        if (`${value}` === '[more information]') {
          if (window.refapp && window.refapp.mctbEcommerce) {
            obj[`${key}`] = window.refapp.mctbEcommerce;
          } else {
            obj[`${key}`] = '';
          }
        } else {
          obj[`${key}`] = `${value}`;
        }
      }

      return obj;
    },
  },
};
</script>
